import React, {useContext, useEffect, useState} from "react";
import api from "../../services/api";
import {Link} from "react-router-dom";
import {ICompetition} from "../../interfaces/ICompetition";
import CompetitionConsolidatedReportPrinting from "./CompetitionConsolidatedReportPrinting";
import ResultsPrinting from "../Event/EventResult/ResultsPrinting";
import {MainContext} from "../../context/MainContext";

export default function CompetitionList() {
    const [competitions, setCompetitions] = useState<ICompetition[]>([])
    const [printingCompetition, setPrintingCompetition] = useState<ICompetition | null>(null)
    const [stageModal, setStageModal] = useState<ICompetition | null>(null)
    const [etapa, setEtapa] = useState('1')
    const [preloadedPages, setPreloadedPages] = useState<any[] | null>(null)
    const {setPageTitle} = useContext(MainContext)

    useEffect(() => {
        setPageTitle('Competições')

        api.get('/api/competitions')
            .then(response => setCompetitions(response.data))
    }, [])

    const handleGenerateByStage = async () => {
        if (!stageModal) return
        const res = await api.get('/api/event_results/report-by-stage', {
            params: { competitionId: stageModal.id, stage: etapa },
        })
        setStageModal(null)
        setPreloadedPages(res.data)
    }

    return (
        <>
            {/*<div className="row">*/}
            {/*    <div className="col-md-12">*/}
            {/*        <h3 className="mb-2">*/}
            {/*            <b>Competições</b>*/}
            {/*        </h3>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className="row my-4">

                {competitions.map(competition =>
                    <div key={competition.id} className="col-md-4 mt-3">
                        {/* <div className="card"> <img className="card-img-top" src="https://static.pingendo.com/cover-moon.svg" alt="Card image cap" /> */}
                        <div className="card">
                            {/*<img className={competition.status === 'finished' ? 'rounded mx-auto d-block img-blur' : 'rounded mx-auto d-block'} style={{maxHeight:'140px'}} src={!competition.image?"/logo192.png": competition.image} alt="Competicao" />*/}
                            <div className="card-body">
                                <h4 className="card-title">{competition.title}</h4>
                                <p className="card-text">{competition.description}</p>

                                <div className="row">
                                    <div className="col-md-12 my-1">
                                        <Link to={`/events/${competition.id}`} className="btn btn-primary w-100"><i className="bi bi-clipboard-data">&nbsp;</i> Acessar</Link>
                                    </div>
                                    {competition.show_result == true && (
                                        <div className="col-md-12 my-1">
                                            <div className="btn-group w-100">
                                                <button type="button" className="btn btn-success w-100" onClick={() => setPrintingCompetition(competition)}>
                                                    <i className="bi bi-trophy-fill">&nbsp;</i>Relatório Geral
                                                </button>
                                                <button type="button" className="btn btn-success dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <span className="visually-hidden">Toggle Dropdown</span>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li className="dropdown-item" style={{cursor:'pointer'}} onClick={() => setStageModal(competition)}>
                                                        <i className="bi bi-file-earmark-spreadsheet-fill">&nbsp;</i> Relatório por etapa
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}

                                  {/*{competition.status !== 'finished' && (*/}
                                  {/*  <CompetitionCalendar competition_id={competition.id}/>*/}
                                  {/*)}*/}

                                </div>

                            </div>
                        </div>

                    </div>
                )}

            </div>
        {printingCompetition && (
            <CompetitionConsolidatedReportPrinting
                key={printingCompetition.id}
                competitionId={printingCompetition.id}
                competitionTitle={printingCompetition.title}
                childToParent={() => setPrintingCompetition(null)}
            />
        )}

        {preloadedPages && (
            <ResultsPrinting
                preloadedPages={preloadedPages}
                childToParent={() => setPreloadedPages(null)}
            />
        )}

        {stageModal && (
            <div className="modal show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Relatório por Etapa</h5>
                            <button type="button" className="btn-close" onClick={() => setStageModal(null)}></button>
                        </div>
                        <div className="modal-body">
                            <div className="alert alert-info">
                                <i className="bi bi-info-circle mx-2"></i>
                                Selecione a etapa para gerar o relatório de todas as competições ativas.
                            </div>
                            <label htmlFor="etapaSelect" className="form-label">Etapa</label>
                            <select className="form-select" id="etapaSelect" value={etapa} onChange={e => setEtapa(e.target.value)}>
                                    <option key={1} value={1}>Jan</option>
                                    <option key={2} value={2}>Fev</option>
                                    <option key={3} value={3}>Mar</option>
                                    <option key={4} value={4}>Abr</option>
                                    <option key={5} value={5}>Mai</option>
                                    <option key={6} value={6}>jun</option>
                                    <option key={7} value={7}>jul</option>
                                    <option key={8} value={8}>Ago</option>
                                    <option key={9} value={9}>Set</option>
                                    <option key={10} value={10}>Out</option>
                                    <option key={11} value={11}>Nov</option>
                                    <option key={12} value={12}>Dez</option>
                            </select>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" onClick={() => setStageModal(null)}>Cancelar</button>
                            <button type="button" className="btn btn-success" onClick={handleGenerateByStage}>Gerar</button>
                        </div>
                    </div>
                </div>
            </div>
        )}
        </>
    );
}
